<template>
  <div class="body">
    <div  class="login-top">
      <div id="w-center" >
        <a href="/">
          <img :src="info.logo" alt="">
        </a>
        <p>忘记密码</p>
      </div>
    </div>
    <div class="login-center">
       <el-tabs v-model="activeName" @tab-click="handleClick" :stretch=true class="long-c">
          <el-tab-pane label="忘记密码" name="first" class="login-text">
              <Forgetpass ></Forgetpass>
          </el-tab-pane>
        </el-tabs>
    </div>
    <div class="h-40"></div>
     <div class="login-botm">{{info.foot}}</div>
  </div>
</template>
<style scoped>
    body{background: #f5f7fa;}
    .login-center >>> .el-tabs__item {font-size: 22px;font-weight: bold;}
    .login-center >>> .el-tabs__active-bar{width: 0px !important;left: 47%;background-color: #2c5fab}
    .login-center >>> .el-tabs__item:hover{color: #2c5fab;}
    .login-center >>> .el-tabs__item.is-active{color: #2c5fab;}
    .login-center >>> .el-tabs__nav-wrap::after{background-color:#f5f7fa !important;}
    .login-center >>> .el-tabs__nav-wrap::after{background-color:#f5f7fa !important;}
</style>
<script>

import forgetpass from '@/components/login/forgetpass.vue'
export default{
  data(){
    return {
      info:[],
      activeName: 'first',
      ptzc:'',
    }
  },
  components: {
    'Forgetpass': forgetpass,  //将别名demo 变成 组件 Demo
  },
  mounted () {
    this.recordapi();
  },
  methods:{
    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Login/Loginshow",{'userid':userid}).then(res => {
          console.log(res);
          that.info= res;
        });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Forgetpass.vue